(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["medico-password-monitor"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const monitors = document.querySelectorAll("[data-medico-monitor]");

    monitors.forEach((monitor) => {
      if (monitor.dataset.initialized === "true") return;
      monitor.dataset.initialized = "true";

      const clock = monitor.querySelector("[data-medico-clock]");
      const heartRate = monitor.querySelector("[data-heart-rate]");
      const audioToggle = monitor.querySelector("[data-audio-toggle]");
      const audioLabel = monitor.querySelector("[data-audio-label]");
      const canvas = monitor.querySelector("[data-game-canvas]");
      const overlay = monitor.querySelector("[data-game-overlay]");
      const title = monitor.querySelector("[data-game-title]");
      const message = monitor.querySelector("[data-game-message]");
      const startButton = monitor.querySelector("[data-game-start]");
      const jumpButton = monitor.querySelector("[data-game-jump]");
      const scoreNode = monitor.querySelector("[data-game-score]");

      if (!canvas) return;

      const context = canvas.getContext("2d");
      let width = 960;
      let height = 360;
      let pixelRatio = 1;
      let frame = 0;
      let lastTime = performance.now();
      let state = "ready";
      let score = 0;
      let speed = 200;
      let spawnTimer = 0;
      let nextSpawn = 1.55;
      let obstacles = [];
      let audioEnabled = false;
      let audioContext = null;
      let lastClockSecond = -1;

      const rat = {
        x: 86,
        y: 0,
        width: 50,
        height: 25,
        velocityY: 0,
        grounded: true
      };

      const colors = {
        background: "#02090d",
        grid: "rgba(120, 222, 254, 0.095)",
        gridStrong: "rgba(120, 222, 254, 0.16)",
        green: getComputedStyle(monitor).getPropertyValue("--medico-green").trim() || "#55ff9d",
        cyan: "#78defe",
        white: "#f3f7f8",
        gray: "#a8b4ba",
        pink: "#f2a5b5",
        red: "#ff3446"
      };

      const groundY = () => height * 0.74;

      const resize = () => {
        const rect = canvas.getBoundingClientRect();
        pixelRatio = Math.min(window.devicePixelRatio || 1, 2);
        width = Math.max(320, rect.width);
        height = Math.max(220, rect.height);
        canvas.width = Math.floor(width * pixelRatio);
        canvas.height = Math.floor(height * pixelRatio);
        context.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        context.imageSmoothingEnabled = false;
        if (state !== "playing") {
          rat.y = groundY() - rat.height;
        }
      };

      const formatScore = (value) => String(value).padStart(3, "0");

      const updateClock = () => {
        if (!clock) return;
        const now = new Date();
        const second = now.getSeconds();
        if (second === lastClockSecond) return;
        lastClockSecond = second;
        clock.textContent = [now.getHours(), now.getMinutes(), second]
          .map((value) => String(value).padStart(2, "0"))
          .join(":");
      };

      const beep = (frequency = 720, duration = 0.055) => {
        if (!audioEnabled) return;
        const AudioConstructor = window.AudioContext || window.webkitAudioContext;
        if (!AudioConstructor) return;
        if (!audioContext) audioContext = new AudioConstructor();
        const oscillator = audioContext.createOscillator();
        const gain = audioContext.createGain();
        oscillator.type = "square";
        oscillator.frequency.value = frequency;
        gain.gain.setValueAtTime(0.025, audioContext.currentTime);
        gain.gain.exponentialRampToValueAtTime(0.0001, audioContext.currentTime + duration);
        oscillator.connect(gain);
        gain.connect(audioContext.destination);
        oscillator.start();
        oscillator.stop(audioContext.currentTime + duration);
      };

      const reset = () => {
        score = 0;
        speed = Math.max(185, width * 0.2);
        spawnTimer = 0;
        nextSpawn = 1.35;
        obstacles = [];
        rat.y = groundY() - rat.height;
        rat.velocityY = 0;
        rat.grounded = true;
        scoreNode.textContent = formatScore(score);
      };

      const start = () => {
        reset();
        state = "playing";
        overlay.classList.add("is-hidden");
        canvas.focus({ preventScroll: true });
        jump();
      };

      const end = () => {
        state = "ended";
        title.textContent = "TEST INTERRUPTED";
        message.textContent = `FINAL SCORE ${formatScore(score)} · TAP TO RETRY`;
        startButton.textContent = "RESTART";
        overlay.classList.remove("is-hidden");
        beep(160, 0.18);
      };

      const jump = () => {
        if (state === "ready" || state === "ended") {
          start();
          return;
        }

        if (!rat.grounded) return;
        rat.velocityY = -Math.max(455, height * 1.5);
        rat.grounded = false;
        beep(480, 0.035);
      };

      const addObstacle = () => {
        const pulseHeight = Math.max(58, Math.min(88, height * (0.21 + Math.random() * 0.055)));
        obstacles.push({
          x: width + 38,
          height: pulseHeight,
          scored: false,
          phase: Math.random() * Math.PI
        });
        nextSpawn = Math.max(0.92, 1.52 - score * 0.007) + Math.random() * 0.34;
      };

      const drawGrid = () => {
        context.fillStyle = colors.background;
        context.fillRect(0, 0, width, height);

        const minor = 18;
        const major = minor * 5;
        const offset = state === "playing" ? (frame * speed * 0.012) % minor : 0;

        context.lineWidth = 1;
        for (let x = -minor + offset; x < width + minor; x += minor) {
          context.strokeStyle = Math.round((x - offset) / minor) % 5 === 0 ? colors.gridStrong : colors.grid;
          context.beginPath();
          context.moveTo(Math.round(x) + 0.5, 0);
          context.lineTo(Math.round(x) + 0.5, height);
          context.stroke();
        }

        for (let y = 0; y < height; y += minor) {
          context.strokeStyle = Math.round(y / major) === y / major ? colors.gridStrong : colors.grid;
          context.beginPath();
          context.moveTo(0, Math.round(y) + 0.5);
          context.lineTo(width, Math.round(y) + 0.5);
          context.stroke();
        }

        const sweepX = (frame * 2.2) % (width + 120) - 60;
        const gradient = context.createLinearGradient(sweepX - 65, 0, sweepX + 35, 0);
        gradient.addColorStop(0, "rgba(85, 255, 157, 0)");
        gradient.addColorStop(0.75, "rgba(85, 255, 157, 0.045)");
        gradient.addColorStop(1, "rgba(85, 255, 157, 0)");
        context.fillStyle = gradient;
        context.fillRect(sweepX - 65, 0, 100, height);
      };

      const pulsePoints = (obstacle) => {
        const baseline = groundY();
        const x = obstacle.x;
        const h = obstacle.height;
        return [
          [x - 38, baseline],
          [x - 22, baseline],
          [x - 14, baseline - 8],
          [x - 7, baseline + 13],
          [x, baseline - h],
          [x + 9, baseline + 28],
          [x + 18, baseline],
          [x + 40, baseline]
        ];
      };

      const drawTrace = () => {
        const baseline = groundY();
        context.save();
        context.shadowColor = colors.green;
        context.shadowBlur = 8;
        context.strokeStyle = colors.green;
        context.lineWidth = 2;
        context.beginPath();
        context.moveTo(0, baseline);

        obstacles.forEach((obstacle) => {
          pulsePoints(obstacle).forEach(([x, y]) => context.lineTo(x, y));
        });

        context.lineTo(width, baseline);
        context.stroke();
        context.restore();

        context.fillStyle = "rgba(85, 255, 157, 0.58)";
        context.fillRect(0, baseline + 14, width, 1);
      };

      const pixel = (x, y, size, color) => {
        context.fillStyle = color;
        context.fillRect(Math.round(x), Math.round(y), size, size);
      };

      const drawRat = () => {
        const x = Math.round(rat.x);
        const y = Math.round(rat.y);
        const p = Math.max(2, Math.round(Math.min(width / 300, height / 130)));
        const bob = state === "playing" && rat.grounded ? Math.sin(frame * 0.35) * p : 0;
        const top = y + bob;
        const runPhase = Math.floor(frame / 5) % 2;

        context.save();
        context.shadowColor = "rgba(243, 247, 248, 0.32)";
        context.shadowBlur = 8;

        pixel(x + 4 * p, top + 4 * p, p, colors.gray);
        pixel(x + 5 * p, top + 3 * p, p, colors.white);
        pixel(x + 6 * p, top + 2 * p, 6 * p, colors.white);
        pixel(x + 12 * p, top + 3 * p, 2 * p, colors.white);
        pixel(x + 14 * p, top + 4 * p, 3 * p, colors.white);
        pixel(x + 17 * p, top + 5 * p, 2 * p, colors.white);
        pixel(x + 8 * p, top + p, 2 * p, colors.pink);
        pixel(x + 9 * p, top + 2 * p, p, colors.white);
        pixel(x + 15 * p, top + 4 * p, p, colors.red);
        pixel(x + 18 * p, top + 6 * p, p, colors.pink);
        pixel(x + 18 * p, top + 5 * p, p, colors.white);

        context.strokeStyle = colors.pink;
        context.lineWidth = p;
        context.lineCap = "square";
        context.beginPath();
        context.moveTo(x + 4 * p, top + 5 * p);
        context.lineTo(x + 2 * p, top + 4 * p);
        context.lineTo(x, top + 5 * p);
        context.lineTo(x - 2 * p, top + 4 * p);
        context.stroke();

        context.strokeStyle = colors.gray;
        context.lineWidth = Math.max(1, p * 0.45);
        context.beginPath();
        context.moveTo(x + 18 * p, top + 6 * p);
        context.lineTo(x + 22 * p, top + 5 * p);
        context.moveTo(x + 18 * p, top + 7 * p);
        context.lineTo(x + 22 * p, top + 7 * p);
        context.stroke();

        const legOffset = runPhase ? p : 0;
        pixel(x + 7 * p - legOffset, top + 7 * p, 2 * p, colors.gray);
        pixel(x + 13 * p + legOffset, top + 7 * p, 2 * p, colors.gray);
        pixel(x + 6 * p - legOffset, top + 8 * p, 2 * p, colors.pink);
        pixel(x + 14 * p + legOffset, top + 8 * p, 2 * p, colors.pink);

        context.restore();
      };

      const drawStatus = () => {
        context.fillStyle = "rgba(120, 222, 254, 0.48)";
        context.font = '9px "Courier New", monospace';
        context.textAlign = "left";
        context.fillText("LEAD II", 12, 18);
        context.textAlign = "right";
        context.fillText(`${Math.round(speed)} PX/S`, width - 12, 18);
      };

      const update = (delta) => {
        if (state !== "playing") return;

        speed = Math.min(360, speed + delta * 2.8);
        spawnTimer += delta;

        if (spawnTimer >= nextSpawn) {
          spawnTimer = 0;
          addObstacle();
        }

        rat.velocityY += Math.max(1150, height * 3.5) * delta;
        rat.y += rat.velocityY * delta;
        const floor = groundY() - rat.height;

        if (rat.y >= floor) {
          rat.y = floor;
          rat.velocityY = 0;
          rat.grounded = true;
        }

        obstacles.forEach((obstacle) => {
          obstacle.x -= speed * delta;

          if (!obstacle.scored && obstacle.x + 18 < rat.x) {
            obstacle.scored = true;
            score += 1;
            scoreNode.textContent = formatScore(score);
            if (heartRate) heartRate.textContent = String(Math.min(164, 86 + score)).padStart(3, "0");
            beep(760 + Math.min(score, 20) * 8, 0.045);
          }

          const collisionX = obstacle.x - 5;
          const collisionWidth = 15;
          const collisionTop = groundY() - obstacle.height;
          const ratInsetX = 7;
          const ratInsetY = 4;

          if (
            rat.x + ratInsetX < collisionX + collisionWidth &&
            rat.x + rat.width - ratInsetX > collisionX &&
            rat.y + ratInsetY < groundY() + 4 &&
            rat.y + rat.height - ratInsetY > collisionTop
          ) {
            end();
          }
        });

        obstacles = obstacles.filter((obstacle) => obstacle.x > -60);
      };

      const render = () => {
        drawGrid();
        drawTrace();
        drawRat();
        drawStatus();
      };

      const loop = (time) => {
        const delta = Math.min((time - lastTime) / 1000, 0.034);
        lastTime = time;
        frame += 1;
        updateClock();
        update(delta);
        render();
        requestAnimationFrame(loop);
      };

      const handleKey = (event) => {
        const tagName = document.activeElement ? document.activeElement.tagName : "";
        if (tagName === "INPUT" || tagName === "TEXTAREA" || tagName === "SELECT") return;
        if (event.code === "Space" || event.code === "ArrowUp" || event.code === "KeyW") {
          event.preventDefault();
          jump();
        }
      };

      startButton.addEventListener("click", start);
      jumpButton.addEventListener("click", jump);
      canvas.addEventListener("pointerdown", jump);
      monitor.addEventListener("keydown", handleKey);

      audioToggle.addEventListener("click", () => {
        audioEnabled = !audioEnabled;
        audioToggle.setAttribute("aria-pressed", String(audioEnabled));
        audioLabel.textContent = audioEnabled ? "SOUND ON" : "SOUND OFF";
        if (audioEnabled) beep(620, 0.06);
      });

      const resizeObserver = new ResizeObserver(resize);
      resizeObserver.observe(canvas);
      resize();
      reset();
      render();
      requestAnimationFrame(loop);

      document.addEventListener("shopify:section:unload", (event) => {
        if (event.detail.sectionId === monitor.id.replace("MedicoPassword-", "")) {
          resizeObserver.disconnect();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
